(function () {
  function getRoutesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function parseCartParam(value) {
    if (!value) return [];

    var decoded = value;
    try {
      decoded = decodeURIComponent(value);
    } catch (error) {
      decoded = value;
    }

    return decoded
      .split(',')
      .map(function (part) {
        var pieces = part.trim().split(':');
        if (!pieces[0]) return null;
        return {
          variantId: pieces[0],
          quantity: Math.max(1, parseInt(pieces[1], 10) || 1)
        };
      })
      .filter(Boolean);
  }

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents == null) {
      return '0';
    }

    var precisionValue = typeof precision === 'undefined' ? 2 : precision;
    var thousandsSeparator = typeof thousands === 'undefined' ? ',' : thousands;
    var decimalSeparator = typeof decimal === 'undefined' ? '.' : decimal;
    var numString = (cents / 100).toFixed(precisionValue);
    var parts = numString.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSeparator);
    var centsPart = parts[1] ? decimalSeparator + parts[1] : '';

    return dollars + centsPart;
  }

  function formatMoney(cents, format) {
    if (!format) {
      return formatWithDelimiters(cents, 2, '.', ',') + ' €';
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/g;

    return format.replace(placeholderRegex, function (match, placeholder) {
      switch (placeholder) {
        case 'amount':
          return formatWithDelimiters(cents, 2);
        case 'amount_no_decimals':
          return formatWithDelimiters(cents, 0);
        case 'amount_with_comma_separator':
          return formatWithDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return formatWithDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return formatWithDelimiters(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return formatWithDelimiters(cents, 0, ' ');
        case 'amount_with_space_separator':
          return formatWithDelimiters(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator':
          return formatWithDelimiters(cents, 2, ' ', '.');
        default:
          return match;
      }
    });
  }

  function formatProductTitle(title) {
    if (!title) return '';
    var pipeIndex = title.indexOf('|');
    if (pipeIndex === -1) return title.trim();
    return title.slice(0, pipeIndex).trim();
  }

  function buildMetafieldsMap(metafieldsEl) {
    if (!metafieldsEl) return {};

    try {
      return JSON.parse(metafieldsEl.textContent);
    } catch (error) {
      return {};
    }
  }

  function parsePriceCents(value) {
    if (value == null || value === '') return 0;

    if (typeof value === 'number') {
      if (!isFinite(value) || value <= 0) return 0;
      if (value % 1 !== 0) {
        return Math.round(value * 100);
      }
      return value;
    }

    if (typeof value === 'string') {
      var normalized = value.replace(/\s/g, '').replace(',', '.');
      var parsed = parseFloat(normalized);
      if (!isFinite(parsed) || parsed <= 0) return 0;
      if (normalized.indexOf('.') > -1) {
        return Math.round(parsed * 100);
      }
      return parsed;
    }

    return 0;
  }

  function mergeProductData(lineItem, metafields) {
    var variantKey = String(lineItem.variant_id);
    var meta = metafields[variantKey] || {};
    var compareAtPrice = parsePriceCents(meta.compareAtPrice);

    if (!compareAtPrice) {
      compareAtPrice = parsePriceCents(lineItem.compare_at_price);
    }

    return {
      title: lineItem.product_title || '',
      subtitle: meta.subtitle || '',
      price: lineItem.price,
      compareAtPrice: compareAtPrice,
      image: lineItem.image || '',
      cuantasTomar: meta.cuantasTomar || '',
      cuandoTomar: meta.cuandoTomar || ''
    };
  }

  function getLineTotalCents(lineItem, requestedQty) {
    if (lineItem && typeof lineItem.line_price === 'number') {
      return lineItem.line_price;
    }

    if (lineItem && typeof lineItem.discounted_price === 'number') {
      return lineItem.discounted_price * requestedQty;
    }

    if (lineItem && typeof lineItem.final_line_price === 'number') {
      return lineItem.final_line_price;
    }

    return (lineItem.price || 0) * requestedQty;
  }

  function getLineCompareTotalCents(lineItem, requestedQty, product, lineTotal) {
    var candidates = [];
    var unitCompare = 0;

    if (product && product.compareAtPrice) {
      unitCompare = product.compareAtPrice;
    } else if (lineItem) {
      unitCompare = parsePriceCents(lineItem.compare_at_price);
    }

    if (unitCompare) {
      candidates.push(unitCompare * requestedQty);
    }

    if (lineItem) {
      var originalLine = parsePriceCents(lineItem.original_line_price);

      if (!originalLine) {
        var originalUnit = parsePriceCents(lineItem.original_price);
        if (originalUnit) {
          originalLine = originalUnit * requestedQty;
        }
      }

      if (originalLine) {
        candidates.push(originalLine);
      }
    }

    var compareTotal = candidates.reduce(function (max, value) {
      return value > max ? value : max;
    }, 0);

    if (compareTotal > lineTotal) {
      return compareTotal;
    }

    return 0;
  }

  function buildResolvedFromCart(updatedCart, cartItems, metafields) {
    var requestedMap = {};
    cartItems.forEach(function (item) {
      requestedMap[String(item.variantId)] = item.quantity;
    });

    var resolved = [];

    (updatedCart.items || []).forEach(function (lineItem) {
      var requestedQty = requestedMap[String(lineItem.variant_id)];
      if (!requestedQty) return;

      var product = mergeProductData(lineItem, metafields);
      var lineTotal = getLineTotalCents(lineItem, requestedQty);

      resolved.push({
        variantId: String(lineItem.variant_id),
        quantity: requestedQty,
        product: product,
        lineTotal: lineTotal,
        lineCompareTotal: getLineCompareTotalCents(lineItem, requestedQty, product, lineTotal)
      });
    });

    if (typeof updatedCart.total_price === 'number') {
      resolved.cartTotal = updatedCart.total_price;
    } else if (typeof updatedCart.items_subtotal_price === 'number' && updatedCart.items_subtotal_price > 0) {
      resolved.cartTotal = updatedCart.items_subtotal_price;
    } else {
      resolved.cartTotal = resolved.reduce(function (sum, entry) {
        return sum + entry.lineTotal;
      }, 0);
    }

    return resolved;
  }

  function buildCartItemsForPaymentForm(updatedCart, cartItems) {
    var requestedMap = {};
    cartItems.forEach(function (item) {
      requestedMap[String(item.variantId)] = item.quantity;
    });

    return (updatedCart.items || [])
      .filter(function (lineItem) {
        return requestedMap[String(lineItem.variant_id)];
      })
      .map(function (lineItem) {
        return {
          variantId: String(lineItem.variant_id),
          quantity: requestedMap[String(lineItem.variant_id)] || lineItem.quantity,
          handle: lineItem.handle || '',
          url: lineItem.url || ''
        };
      });
  }

  function extractDiscountInfo(cart, discountCode) {
    if (!cart) {
      return {
        code: discountCode || '',
        percent: 0,
        amount: 0,
        subtotal: 0,
        total: 0,
        hasDiscount: false
      };
    }

    var applications = cart.cart_level_discount_applications || [];
    var subtotal =
      typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : typeof cart.original_total_price === 'number'
          ? cart.original_total_price
          : 0;
    var total = typeof cart.total_price === 'number' ? cart.total_price : subtotal;
    var discountAmount = 0;
    var percent = 0;
    var code = discountCode || '';

    applications.forEach(function (application) {
      var allocated = application.total_allocated_amount || 0;
      discountAmount += allocated;

      if (application.value_type === 'percentage' && allocated > 0 && !percent) {
        percent = parseFloat(application.value) || 0;
      }

      if (!code && application.title) {
        code = application.title;
      }
    });

    if (!code && discountCode) {
      code = discountCode;
    }

    if (!percent && subtotal > 0 && discountAmount > 0) {
      percent = Math.round((discountAmount / subtotal) * 1000) / 10;
    }

    return {
      code: code,
      percent: percent,
      amount: discountAmount,
      subtotal: subtotal,
      total: total,
      hasDiscount: discountAmount > 0
    };
  }

  function isRateLimitedResponse(response) {
    return response && (response.status === 429 || response.status === 503);
  }

  async function fetchCartApi(url, options, maxAttempts) {
    var attempts = maxAttempts || 6;
    var opts = options || {};
    var response = null;
    var i;

    for (i = 0; i < attempts; i++) {
      if (i > 0) {
        await wait(300 + 200 * i);
      }

      response = await fetch(url, opts);

      if (response.ok || !isRateLimitedResponse(response)) {
        return response;
      }
    }

    return response;
  }

  async function parseJsonResponse(response) {
    if (!response || !response.ok) return null;

    try {
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  async function fetchCartJson(root, maxAttempts) {
    var response = await fetchCartApi(
      root + 'cart.js',
      { credentials: 'same-origin' },
      maxAttempts
    );

    return parseJsonResponse(response);
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function getExpectedItemCount(cartItems) {
    return cartItems.reduce(function (sum, item) {
      return sum + item.quantity;
    }, 0);
  }

  function cartHasExpectedItems(cart, cartItems) {
    if (!cart || !cartItems.length) return false;

    var expected = getExpectedItemCount(cartItems);
    if (!cart.item_count || cart.item_count < expected) return false;

    var requestedMap = {};
    cartItems.forEach(function (item) {
      requestedMap[String(item.variantId)] = item.quantity;
    });

    var matchedQty = 0;
    (cart.items || []).forEach(function (lineItem) {
      var requestedQty = requestedMap[String(lineItem.variant_id)];
      if (requestedQty) {
        matchedQty += Math.min(lineItem.quantity || 0, requestedQty);
      }
    });

    return matchedQty >= expected;
  }

  function normalizeDiscountCode(code) {
    return String(code || '').trim().toUpperCase();
  }

  function isDiscountApplied(cart, discountCode) {
    var normalized = normalizeDiscountCode(discountCode);
    if (!normalized) return true;
    if (!cart) return false;

    var codes = cart.discount_codes || [];
    var i;

    for (i = 0; i < codes.length; i++) {
      if (normalizeDiscountCode(codes[i].code) === normalized && codes[i].applicable) {
        return true;
      }
    }

    var applications = cart.cart_level_discount_applications || [];
    for (i = 0; i < applications.length; i++) {
      var app = applications[i];
      if (app.type !== 'discount_code') continue;

      if (normalizeDiscountCode(app.title) === normalized && (app.total_allocated_amount > 0 || app.value)) {
        return true;
      }
    }

    return false;
  }

  async function clearAndAddCartItems(root, cartItems) {
    var clearResponse = await fetchCartApi(root + 'cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin'
    });

    if (!clearResponse.ok) {
      return false;
    }

    var addResponse = await fetchCartApi(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: cartItems.map(function (item) {
          return { id: Number(item.variantId), quantity: item.quantity };
        })
      })
    });

    return addResponse.ok;
  }

  async function waitForCartItems(root, cartItems, maxAttempts) {
    var attempts = maxAttempts || 6;
    var cart = null;
    var i;

    for (i = 0; i < attempts; i++) {
      if (i > 0) {
        await wait(100 * i);
      }

      cart = await fetchCartJson(root);
      if (cartHasExpectedItems(cart, cartItems)) {
        return cart;
      }
    }

    return cart;
  }

  async function applyDiscountWithRetry(root, discountCode, maxAttempts) {
    var normalized = String(discountCode || '').trim();
    if (!normalized) {
      return fetchCartJson(root);
    }

    var attempts = maxAttempts || 5;
    var lastCart = null;
    var i;

    for (i = 0; i < attempts; i++) {
      if (i > 0) {
        await wait(150 * i);
      }

      var updateResponse = await fetchCartApi(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: normalized })
      });

      if (!updateResponse.ok) {
        continue;
      }

      var updatedCart = await parseJsonResponse(updateResponse);
      lastCart = (await fetchCartJson(root)) || updatedCart;

      if (isDiscountApplied(lastCart, normalized)) {
        return lastCart;
      }
    }

    return lastCart;
  }

  async function prepareCartWithDiscount(root, cartItems, discountCode) {
    var maxPrepareAttempts = 5;
    var attempt;

    for (attempt = 0; attempt < maxPrepareAttempts; attempt++) {
      if (attempt > 0) {
        await wait(500 * attempt);
      }

      var added = await clearAndAddCartItems(root, cartItems);
      if (!added) {
        continue;
      }

      var cart = await waitForCartItems(root, cartItems, 8);
      if (!cartHasExpectedItems(cart, cartItems)) {
        continue;
      }

      await wait(150);

      cart = await applyDiscountWithRetry(root, discountCode, 5);

      if (cartHasExpectedItems(cart, cartItems)) {
        return cart;
      }
    }

    return null;
  }

  function isApplePayDebugEnabled() {
    return window.location.search.indexOf('ru_pauta_debug') > -1;
  }

  function reportApplePayDebug(root, slot, info) {
    var payload = Object.assign({ ts: new Date().toISOString() }, info);

    if (slot) {
      try {
        slot.dataset.applePayDebug = JSON.stringify(payload);
      } catch (error) {
        slot.dataset.applePayDebug = String(payload.status || 'error');
      }
    }

    if (root) {
      var panel = root.querySelector('[data-apple-pay-debug-panel]');
      if (panel && isApplePayDebugEnabled()) {
        panel.hidden = false;
        panel.textContent = JSON.stringify(payload, null, 2);
      }
    }

    if (isApplePayDebugEnabled() || (info && info.status && info.status !== 'injected')) {
      console.warn('[ru-pauta] Apple Pay debug:', payload);
    }
  }

  function initPaymentButtons() {
    if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
      window.Shopify.PaymentButton.init();
    }
  }

  function getProductHandleFromCartItem(item) {
    if (!item) return '';

    if (item.handle) {
      return item.handle;
    }

    if (item.url) {
      var match = item.url.match(/\/products\/([^/?#]+)/i);
      if (match && match[1]) {
        return decodeURIComponent(match[1]);
      }
    }

    return '';
  }

  function buildAdditionalItemsInputs(cartItems, mainVariantId) {
    var additionalIndex = 1;
    var html = '';

    cartItems.forEach(function (item) {
      if (String(item.variantId) === String(mainVariantId)) {
        return;
      }

      html +=
        '<input type="hidden" name="shopify-additional-items[' +
        additionalIndex +
        '][id]" value="' +
        item.variantId +
        '">' +
        '<input type="hidden" name="shopify-additional-items[' +
        additionalIndex +
        '][quantity]" value="' +
        item.quantity +
        '">';
      additionalIndex += 1;
    });

    return html;
  }

  async function fetchProductPaymentForm(cartItems, debugContext) {
    if (!cartItems.length) {
      return null;
    }

    var root = getRoutesRoot();
    var mainItem = cartItems[0];
    var handle = getProductHandleFromCartItem(mainItem);

    if (!handle) {
      reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
        status: 'product-form-no-handle',
        mainVariantId: mainItem.variantId
      });
      return null;
    }

    var sectionId = 'ru-pauta-payment-form';
    var url =
      root.replace(/\/$/, '') +
      '/products/' +
      encodeURIComponent(handle) +
      '?sections=' +
      encodeURIComponent(sectionId);

    reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
      status: 'product-form-fetch-start',
      handle: handle,
      url: url
    });

    var response = await fetch(url, { credentials: 'same-origin' });

    if (!response.ok) {
      reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
        status: 'product-form-fetch-failed',
        handle: handle,
        httpStatus: response.status
      });
      return null;
    }

    var data = await response.json();
    var sectionHtml = data[sectionId];

    if (!sectionHtml) {
      reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
        status: 'product-form-null',
        handle: handle
      });
      return null;
    }

    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var form = doc.querySelector('form.ru-pauta__payment-form, form[action*="/cart/add"]');

    if (!form) {
      reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
        status: 'product-form-missing',
        handle: handle,
        htmlLength: sectionHtml.length
      });
      return null;
    }

    var variantInput = form.querySelector('[data-ru-pauta-main-variant], input[name="id"]');
    var qtyInput = form.querySelector('[data-ru-pauta-main-qty], input[name="quantity"]');

    if (variantInput) {
      variantInput.value = mainItem.variantId;
    }

    if (qtyInput) {
      qtyInput.value = mainItem.quantity;
    }

    form.insertAdjacentHTML('beforeend', buildAdditionalItemsInputs(cartItems, mainItem.variantId));

    reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
      status: 'product-form-ok',
      handle: handle,
      htmlLength: sectionHtml.length,
      hasPaymentButton: !!form.querySelector('.shopify-payment-button, [data-shopify="payment-button"]')
    });

    return form.outerHTML;
  }

  function extractAcceleratedFragment(sectionHtml) {
    if (!sectionHtml) return null;

    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var paymentForm = doc.querySelector('form.ru-pauta__payment-form, form[action*="/cart/add"]');

    if (
      paymentForm &&
      paymentForm.querySelector('.shopify-payment-button, [data-shopify="payment-button"]')
    ) {
      return paymentForm.outerHTML;
    }

    var selectors = [
      '.ru-pauta__accelerated-checkout',
      '.additional-checkout-buttons',
      '[data-shopify="payment-button"]',
      'shopify-accelerated-checkout-cart',
      'shopify-accelerated-checkout'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var node = doc.querySelector(selectors[i]);
      if (!node) continue;

      if (node.matches('shopify-accelerated-checkout-cart, shopify-accelerated-checkout')) {
        var wrapper = document.createElement('div');
        wrapper.className = 'additional-checkout-buttons ru-pauta__accelerated-checkout';
        wrapper.appendChild(node.cloneNode(true));
        return wrapper.outerHTML;
      }

      if (node.innerHTML && node.innerHTML.trim()) {
        return node.outerHTML;
      }

      if (node.querySelector('shopify-accelerated-checkout-cart, shopify-accelerated-checkout, .shopify-payment-button')) {
        return node.outerHTML;
      }
    }

    return null;
  }

  function slotHasCheckoutButtons(slot) {
    if (!slot) return false;

    return !!slot.querySelector(
      'shopify-accelerated-checkout-cart, shopify-accelerated-checkout, .shopify-payment-button, [data-shopify="payment-button"]'
    );
  }

  function injectAcceleratedCheckout(slot, sectionHtml, debugContext) {
    if (!slot) {
      return false;
    }

    if (!sectionHtml) {
      reportApplePayDebug(debugContext && debugContext.root, slot, {
        status: 'empty-html',
        sectionId: debugContext && debugContext.sectionId,
        step: debugContext && debugContext.step
      });
      return false;
    }

    var fragmentHtml = extractAcceleratedFragment(sectionHtml);

    if (!fragmentHtml) {
      reportApplePayDebug(debugContext && debugContext.root, slot, {
        status: 'no-buttons-in-html',
        sectionId: debugContext && debugContext.sectionId,
        step: debugContext && debugContext.step,
        htmlLength: sectionHtml.length
      });
      return false;
    }

    slot.innerHTML = fragmentHtml;

    initPaymentButtons();
    window.setTimeout(initPaymentButtons, 250);
    window.setTimeout(initPaymentButtons, 1000);
    window.setTimeout(initPaymentButtons, 2000);

    var hasButtons = slotHasCheckoutButtons(slot);

    reportApplePayDebug(debugContext && debugContext.root, slot, {
      status: hasButtons ? 'injected' : 'fragment-without-buttons',
      sectionId: debugContext && debugContext.sectionId,
      step: debugContext && debugContext.step,
      htmlLength: sectionHtml.length,
      fragmentLength: fragmentHtml.length
    });

    return hasButtons;
  }

  function pickAcceleratedSectionHtml(sectionsMap, sectionIds) {
    if (!sectionsMap || !sectionIds || !sectionIds.length) return { html: null, sectionId: null };

    for (var i = 0; i < sectionIds.length; i++) {
      var sectionId = sectionIds[i];
      var html = sectionsMap[sectionId];

      if (!html) continue;

      if (extractAcceleratedFragment(html)) {
        return { html: html, sectionId: sectionId };
      }
    }

    for (var j = 0; j < sectionIds.length; j++) {
      var fallbackId = sectionIds[j];
      if (sectionsMap[fallbackId]) {
        return { html: sectionsMap[fallbackId], sectionId: fallbackId };
      }
    }

    return { html: null, sectionId: null };
  }

  async function fetchAcceleratedSectionHtml(sectionIds, debugContext) {
    var root = getRoutesRoot();
    var cartBase = root.replace(/\/$/, '') + '/cart';
    var sectionsParam = sectionIds.join(',');
    var getUrl = cartBase + '?sections=' + encodeURIComponent(sectionsParam);
    var attempt;

    for (attempt = 0; attempt < 4; attempt++) {
      if (attempt > 0) {
        await wait(150 * attempt);
      }

      reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
        status: 'fetch-get-start',
        sectionIds: sectionIds,
        url: getUrl,
        attempt: attempt + 1
      });

      var getResponse = await fetchCartApi(getUrl, { credentials: 'same-origin' }, 4);

      if (!getResponse.ok) {
        reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
          status: 'fetch-get-failed',
          sectionIds: sectionIds,
          httpStatus: getResponse.status,
          attempt: attempt + 1
        });
        continue;
      }

      var getData = await parseJsonResponse(getResponse);
      if (!getData) {
        continue;
      }

      var picked = pickAcceleratedSectionHtml(getData, sectionIds);

      reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
        status: picked.html ? 'fetch-get-ok' : 'fetch-get-null',
        sectionId: picked.sectionId,
        sectionIds: sectionIds,
        htmlLength: picked.html ? picked.html.length : 0,
        attempt: attempt + 1
      });

      if (picked.html) {
        return picked;
      }
    }

    var updateResponse = await fetchCartApi(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sections: sectionsParam,
        sections_url: cartBase
      })
    }, 4);

    if (!updateResponse.ok) {
      reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
        status: 'fetch-update-failed',
        sectionIds: sectionIds,
        httpStatus: updateResponse.status
      });
      return { html: null, sectionId: null };
    }

    var updatedCart = await parseJsonResponse(updateResponse);
    var pickedFromUpdate = pickAcceleratedSectionHtml(updatedCart.sections, sectionIds);

    reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
      status: pickedFromUpdate.html ? 'fetch-update-ok' : 'fetch-update-null',
      sectionId: pickedFromUpdate.sectionId,
      sectionIds: sectionIds,
      htmlLength: pickedFromUpdate.html ? pickedFromUpdate.html.length : 0,
      cartItemCount: updatedCart.item_count
    });

    return pickedFromUpdate;
  }

  async function preparePautaCartDisplay(cartItems, metafields, discountCode) {
    if (!cartItems.length) {
      return { resolved: [], discountInfo: null };
    }

    var root = getRoutesRoot();

    try {
      var cart = await prepareCartWithDiscount(root, cartItems, discountCode);

      if (!cart || !cartHasExpectedItems(cart, cartItems)) {
        return { resolved: [], discountInfo: null };
      }

      if (discountCode && !isDiscountApplied(cart, discountCode)) {
        cart = await applyDiscountWithRetry(root, discountCode, 3);
      }

      if (!cart) {
        return { resolved: [], discountInfo: null };
      }

      return {
        resolved: buildResolvedFromCart(cart, cartItems, metafields),
        discountInfo: extractDiscountInfo(cart, discountCode)
      };
    } catch (error) {
      return { resolved: [], discountInfo: null };
    }
  }

  async function preparePautaCart(cartItems, metafields, discountCode, sectionIds, debugContext) {
    if (!cartItems.length) {
      return { resolved: [], sectionsHtml: null, sectionId: null };
    }

    var root = getRoutesRoot();

    try {
      reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
        status: 'prepare-start',
        itemCount: cartItems.length,
        discountCode: discountCode || null,
        sectionIds: sectionIds
      });

      var cart = await prepareCartWithDiscount(root, cartItems, discountCode);

      if (!cart || !cartHasExpectedItems(cart, cartItems)) {
        reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
          status: 'prepare-missing-items',
          cartItemCount: cart && cart.item_count ? cart.item_count : 0
        });
        return { resolved: [], sectionsHtml: null, sectionId: null };
      }

      if (discountCode && !isDiscountApplied(cart, discountCode)) {
        reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
          status: 'discount-retry',
          discountCode: discountCode
        });
        cart = await applyDiscountWithRetry(root, discountCode, 3);
      }

      if (!cart) {
        return { resolved: [], sectionsHtml: null, sectionId: null };
      }

      reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
        status: 'prepare-cart-ready',
        cartItemCount: cart.item_count,
        discountApplied: isDiscountApplied(cart, discountCode)
      });

      var picked = await fetchAcceleratedSectionHtml(sectionIds, debugContext);
      var paymentHtml = picked.html;

      return {
        resolved: buildResolvedFromCart(cart, cartItems, metafields),
        sectionsHtml: paymentHtml,
        sectionId: picked.sectionId,
        cartItems: buildCartItemsForPaymentForm(cart, cartItems),
        discountInfo: extractDiscountInfo(cart, discountCode)
      };
    } catch (error) {
      reportApplePayDebug(debugContext && debugContext.root, debugContext && debugContext.slot, {
        status: 'prepare-error',
        message: error && error.message ? error.message : String(error)
      });
      return { resolved: [], sectionsHtml: null, sectionId: null };
    }
  }

  function markPautaReady(root) {
    if (!root) return;

    var loader = root.querySelector('[data-ru-pauta-loader]');
    if (loader) {
      loader.setAttribute('aria-busy', 'false');
    }

    root.classList.remove('ru-pauta--loading');
    root.classList.add('ru-pauta--ready');
    document.documentElement.classList.remove('ru-pauta-page-loading');
  }

  async function initRuPauta(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var metafieldsEl = document.getElementById(root.dataset.metafieldsId);
    var metafields = buildMetafieldsMap(metafieldsEl);

    var config = {
      moneyFormat: root.dataset.moneyFormat || '{{amount}}€',
      emptyMessage: root.dataset.emptyMessage || '',
      emptyRetryLabel: root.dataset.emptyRetryLabel || 'Intentar de nuevo',
      discountPrefix: root.dataset.discountPrefix || 'Código de descuento:',
      cartRoot: (root.dataset.cartRoot || '/cart/').replace(/\/?$/, '/'),
      checkoutLabel: root.dataset.checkoutLabel || 'Comprar ahora',
      hideApplePay: root.dataset.hideApplePay === 'true',
      acceleratedSectionIds: (root.dataset.acceleratedSectionIds || 'ru-pauta-accelerated-checkout,main-cart')
        .split(',')
        .map(function (id) {
          return id.trim();
        })
        .filter(Boolean)
    };

    var params = new URLSearchParams(window.location.search);
    var cartItems = parseCartParam(params.get('cart'));
    var discountCode = (params.get('discount') || '').trim();

    var productsEl = root.querySelector('[data-products]');
    var discountEl = root.querySelector('[data-discount-label]');
    var compareEl = root.querySelector('[data-compare-price]');
    var totalEl = root.querySelector('[data-total-price]');
    var buyBtn = root.querySelector('[data-buy-btn]');
    var applePaySlot = root.querySelector('[data-apple-pay-slot]');

    var resolved = [];
    var discountInfo = null;

    if (productsEl && cartItems.length) {
      productsEl.innerHTML = '<p class="ru-pauta__empty">Cargando productos...</p>';
    }

    try {
      if (!config.hideApplePay && applePaySlot && cartItems.length) {
        var debugContext = { root: root, slot: applePaySlot };
        var prepared = await preparePautaCart(
          cartItems,
          metafields,
          discountCode,
          config.acceleratedSectionIds,
          debugContext
        );

        resolved = prepared.resolved;
        discountInfo = prepared.discountInfo;

        var injected = injectAcceleratedCheckout(applePaySlot, prepared.sectionsHtml, {
          root: root,
          sectionId: prepared.sectionId,
          step: 'after-prepare-cart-sections'
        });

        if (!injected) {
          var productFormHtml = await fetchProductPaymentForm(
            prepared.cartItems && prepared.cartItems.length ? prepared.cartItems : cartItems,
            debugContext
          );
          injectAcceleratedCheckout(applePaySlot, productFormHtml, {
            root: root,
            sectionId: 'ru-pauta-payment-form',
            step: 'after-prepare-product-form'
          });
        }
      } else if (cartItems.length) {
        var displayPrepared = await preparePautaCartDisplay(cartItems, metafields, discountCode);
        resolved = displayPrepared.resolved;
        discountInfo = displayPrepared.discountInfo;
      }
    } catch (error) {
      // Mantener la UI usable aunque falle la preparación del carrito.
    }

    if (discountCode && cartItems.length && resolved.length && (!discountInfo || !discountInfo.hasDiscount)) {
      try {
        var retryCart = await applyDiscountWithRetry(getRoutesRoot(), discountCode, 3);

        if (retryCart && isDiscountApplied(retryCart, discountCode)) {
          resolved = buildResolvedFromCart(retryCart, cartItems, metafields);
          discountInfo = extractDiscountInfo(retryCart, discountCode);
        }
      } catch (retryError) {
        // Ignorar y mostrar el estado actual del carrito.
      }
    }

    if (!resolved.length && cartItems.length) {
      try {
        var fallbackCart = await prepareCartWithDiscount(getRoutesRoot(), cartItems, discountCode);

        if (fallbackCart && cartHasExpectedItems(fallbackCart, cartItems)) {
          resolved = buildResolvedFromCart(fallbackCart, cartItems, metafields);
          discountInfo = extractDiscountInfo(fallbackCart, discountCode);
        }
      } catch (fallbackError) {
        // Ignorar y mostrar el estado actual del carrito.
      }
    }

    function renderEmptyState() {
      if (!productsEl) return;

      productsEl.innerHTML = '';

      var emptyWrap = document.createElement('p');
      emptyWrap.className = 'ru-pauta__empty';

      if (config.emptyRetryLabel) {
        var retryBtn = document.createElement('button');
        retryBtn.type = 'button';
        retryBtn.className = 'ru-pauta__empty-retry';
        retryBtn.textContent = config.emptyRetryLabel;
        retryBtn.addEventListener('click', function () {
          window.location.reload();
        });
        emptyWrap.appendChild(retryBtn);
        emptyWrap.appendChild(document.createTextNode(' '));
      }

      var emptyText = document.createElement('span');
      emptyText.className = 'ru-pauta__empty-text';
      emptyText.textContent = config.emptyMessage;
      emptyWrap.appendChild(emptyText);

      productsEl.appendChild(emptyWrap);
    }

    function renderProducts() {
      if (!productsEl) return;

      productsEl.innerHTML = '';

      if (!resolved.length) {
        renderEmptyState();
        return;
      }

      resolved.forEach(function (entry) {
        var product = entry.product;
        var card = document.createElement('article');
        card.className = 'ru-pauta__card';

        var tagsHtml = '';
        if (product.cuantasTomar) {
          tagsHtml += '<span class="ru-pauta__tag">' + product.cuantasTomar + '</span>';
        }
        if (product.cuandoTomar) {
          tagsHtml += '<span class="ru-pauta__tag">' + product.cuandoTomar + '</span>';
        }

        var comparePriceHtml = '';
        if (entry.lineCompareTotal > entry.lineTotal) {
          comparePriceHtml =
            '<p class="ru-pauta__footer-compare">' + formatMoney(entry.lineCompareTotal, config.moneyFormat) + '</p>';
        }

        card.innerHTML =
          '<div class="ru-pauta__card-main">' +
            '<div class="ru-pauta__card-image-wrap">' +
              (product.image ? '<img class="ru-pauta__card-image" src="' + product.image + '" alt="" loading="lazy">' : '') +
            '</div>' +
            '<div class="ru-pauta__card-content">' +
              '<div class="ru-pauta__card-text">' +
                '<p class="ru-pauta__card-name">' + formatProductTitle(product.title) + '</p>' +
                (product.subtitle ? '<p class="ru-pauta__card-subtitle">' + product.subtitle + '</p>' : '') +
              '</div>' +
              (tagsHtml ? '<div class="ru-pauta__tags">' + tagsHtml + '</div>' : '') +
            '</div>' +
          '</div>' +
          '<div class="ru-pauta__card-price-col">' +
            '<p class="ru-pauta__card-qty">Cantidad: ' + entry.quantity + '</p>' +
            '<div class="ru-pauta__footer-prices">' +
              comparePriceHtml +
              '<p class="ru-pauta__card-price">' + formatMoney(entry.lineTotal, config.moneyFormat) + '</p>' +
            '</div>' +
          '</div>';

        productsEl.appendChild(card);
      });
    }

    function formatDiscountPercent(percent) {
      if (Math.floor(percent) === percent) {
        return String(Math.floor(percent));
      }

      return String(percent);
    }

    function updateTotals() {
      var info = discountInfo || {};
      var hasDiscount = !!info.hasDiscount;
      var displayCode = info.code || discountCode;

      if (discountEl) {
        if (displayCode) {
          var label = config.discountPrefix + ' ' + displayCode;

          if (hasDiscount && info.percent > 0) {
            label += ' (-' + formatDiscountPercent(info.percent) + '%)';
          }

          discountEl.textContent = label;
        } else {
          discountEl.textContent = '';
        }
      }

      if (compareEl) {
        if (hasDiscount && info.subtotal > info.total) {
          compareEl.textContent = formatMoney(info.subtotal, config.moneyFormat);
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }

      if (totalEl) {
        var finalTotal;

        if (hasDiscount && typeof info.total === 'number') {
          finalTotal = info.total;
        } else if (typeof resolved.cartTotal === 'number') {
          finalTotal = resolved.cartTotal;
        } else {
          finalTotal = resolved.reduce(function (sum, entry) {
            return sum + entry.lineTotal;
          }, 0);
        }

        totalEl.textContent = formatMoney(finalTotal, config.moneyFormat);
      }
    }

    function goToCheckout() {
      if (!resolved.length) return;

      var checkoutUrl = config.cartRoot.replace(/cart\/?$/, 'checkout');
      window.location.href = checkoutUrl;
    }

    renderProducts();
    updateTotals();

    if (buyBtn) {
      buyBtn.textContent = config.checkoutLabel;
      buyBtn.addEventListener('click', goToCheckout);
      buyBtn.disabled = !resolved.length;
    }

    markPautaReady(root);
  }

  function hideThirdPartyWidgets() {
    var isPautaPage = document.documentElement.classList.contains('ru-pauta-page') ||
      document.documentElement.classList.contains('ru-pauta-page-loading');

    if (!isPautaPage) return;

    var hideStyle = 'display:none!important;visibility:hidden!important;pointer-events:none!important;opacity:0!important;';

    document.querySelectorAll('konvo-widget').forEach(function (widget) {
      var target = widget.closest('.shopify-app-block, .shopify-block') || widget;
      target.setAttribute('aria-hidden', 'true');
      target.style.cssText = hideStyle;
    });

    document.querySelectorAll('[id^="alia-popup-root"], [id^="alia-"]').forEach(function (node) {
      node.setAttribute('aria-hidden', 'true');
      node.style.cssText = hideStyle;
    });
  }

  function initThirdPartyWidgetHider() {
    hideThirdPartyWidgets();

    if (typeof MutationObserver === 'undefined' || !document.body) return;

    var observer = new MutationObserver(hideThirdPartyWidgets);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  var PAUTA_BOOT_DELAY_MS = 800;

  function scheduleBoot() {
    initThirdPartyWidgetHider();

    window.setTimeout(function () {
      document.querySelectorAll('[data-ru-pauta]').forEach(function (root) {
        initRuPauta(root);
      });
    }, PAUTA_BOOT_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBoot);
  } else {
    scheduleBoot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-ru-pauta]');
    if (section) initRuPauta(section);
  });
})();
